function isHiddenMessage(
  message: Vingle.Talk.IMessage,
  currentUser: Vingle.User.IUser | null,
) {
  const isAuthor = Boolean(currentUser && message.user.id === currentUser.id);
  return !isAuthor && Boolean(message.hidden);
}

export default isHiddenMessage;
